import { Td, Tr } from '@chakra-ui/react';
import { selectSnapOperation } from '@ui/features/quote-builder/state/selectors/snap-operation';
import { useSelector } from '@ui/hooks/useSelector';

import { useQuoteLineContext } from '../../QuoteLineProvider';
import { OperationCell } from './OperationCell';
import { RequirementsRow } from './Requirements';

type OpertionRowProps = {
  snapOperationUuid: string;
};

export const operationHeaders = [
  'Seq No.',
  'Resource ID',
  'Quantity',
  'Run Rate',
  'Run Rate Type',
  'Setup Hours',
  'Setup Cost/Hr',
  'Run Cost/Unit',
  'Run Cost/Hr',
  'Burden Setup Cost/Hr',
  'Burden Run Cost/Hr',
  'Burden Run Cost/Unit',
  'Burden % Setup',
  'Burden % Run',
  'Base Service Charge',
  'Min Service Charge',
  'Scrap Yield Type',
  'Scrap Yield %',
  'Scrap Fixed Units',
];

export function OperationRow({ snapOperationUuid }: OpertionRowProps) {
  const { quoteLineUuid } = useQuoteLineContext();
  const snapOperation = useSelector((state) =>
    selectSnapOperation(state, quoteLineUuid, snapOperationUuid),
  );

  return (
    <>
      <Tr>
        <Td>{snapOperation.sequenceNo}</Td>

        <Td>{snapOperation.resourceId}</Td>

        <Td>{snapOperation.loadSizeQty?.toString() ?? ''}</Td>

        <Td>{snapOperation.run?.toString() ?? ''}</Td>

        <Td>{snapOperation.runType}</Td>

        <Td>
          <OperationCell
            snapOperationUuid={snapOperationUuid}
            field="setupHrs"
          />
        </Td>

        <Td>
          <OperationCell
            snapOperationUuid={snapOperationUuid}
            field="setupCostPerHr"
          />
        </Td>

        <Td>
          <OperationCell
            snapOperationUuid={snapOperationUuid}
            field="runCostPerUnit"
          />
        </Td>

        <Td>
          <OperationCell
            snapOperationUuid={snapOperationUuid}
            field="runCostPerHr"
          />
        </Td>

        <Td>
          <OperationCell
            snapOperationUuid={snapOperationUuid}
            field="burPerHrSetup"
          />
        </Td>

        <Td>
          <OperationCell
            snapOperationUuid={snapOperationUuid}
            field="burPerHrRun"
          />
        </Td>

        <Td>
          <OperationCell
            snapOperationUuid={snapOperationUuid}
            field="burPerUnitRun"
          />
        </Td>

        <Td>
          <OperationCell
            snapOperationUuid={snapOperationUuid}
            field="burPercentSetup"
          />
        </Td>

        <Td>
          <OperationCell
            snapOperationUuid={snapOperationUuid}
            field="burPercentRun"
          />
        </Td>

        <Td>
          <OperationCell
            snapOperationUuid={snapOperationUuid}
            field="serviceBaseCharge"
          />
        </Td>

        <Td>
          <OperationCell
            snapOperationUuid={snapOperationUuid}
            field="serviceMinCharge"
          />
        </Td>

        <Td>{snapOperation.scrapYieldType}</Td>

        <Td>
          <OperationCell
            snapOperationUuid={snapOperationUuid}
            field="scrapYieldPct"
          />
        </Td>

        <Td>
          <OperationCell
            snapOperationUuid={snapOperationUuid}
            field="fixedScrapUnits"
          />
        </Td>
      </Tr>

      {snapOperation.snapRequirementUuids.length > 0 && (
        <Tr>
          <Td colSpan={operationHeaders.length}>
            <RequirementsRow snapOperationUuid={snapOperationUuid} />
          </Td>
        </Tr>
      )}
    </>
  );
}
